module.exports = __webpack_public_path__ + "fonts/opensans-extrabolditalic.494709cb.woff";